import { VCS_INTEGRATIONS_PATH } from "../constants";

export const VCS_INTEGRATIONS_LIST_PATH = VCS_INTEGRATIONS_PATH;

export const MANAGE_INTEGRATIONS_PATH = "manage/:provider";
export const EDIT_INTEGRATIONS_PATH = "edit/:provider/:id";
